import Vue from "vue";
import VueRouter from "vue-router";
import Container from "../components/Container.vue";
import { authGuard } from "../lt/auth-module";
import { storeRoutes } from "../lt/store-module";
import { dentalClinicRoutes } from "../dental-clinic-module";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("../lt/auth-module/LoginView.vue"),
    props: {
      afterLogged: ({ $router, $store }) => {
        if($store.state.config.client.dental_default_page) {
          $router.push($store.state.config.client.dental_default_page);
        } else {
          $router.push({ name: "home" });
        }
      }
    }
  },
  {
    path: "/",
    component: Container,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        name: "home",
        redirect: "/dental-clinic/"
      },
      {
        path: "/profile",
        component: () => import("../components/ProfilePage.vue")
      },
      storeRoutes,
      dentalClinicRoutes,
      {
        path: "reports/quotes-fs",
        component: () => import("../dental-clinic-module/reports/QuoteFullScreen.vue"),
      }
    ]
  },

  {
    path: "/about",
    name: "about",
    component: () => import("../views/About.vue")
  },
  {
    path: "/upload-files",
    component: () => import("../components/UploadFiles.vue")
  }
];

const router = new VueRouter({
  routes
});

/** @Guards */
router.beforeEach(authGuard);

export default router;
